'use client'

import React from 'react'
import Modal from '../shared/Modal'
import { useTranslation, Trans } from 'react-i18next'

const TermsOfService = ({ isOpen, onClose, onAccept }) => {
  const { t, i18n } = useTranslation()
  const today = new Date().toLocaleDateString(i18n.language)

  // Рендер контента с поддержкой strong, ссылок, email
  const renderContent = content => {
    const items = Array.isArray(content) ? content : [content]
    return items.map((item, idx) => (
      <p key={idx}>
        <Trans
          i18nKey={item}
          components={[
            <strong key='0' />,
            <strong key='1' />,
            <strong key='2' />,
            <a key='link' href='https://swipey.ai/' target='_blank' rel='noopener noreferrer' />,
            <a key='mail' href='mailto:admin@invai.tech' />,
          ]}
        />
      </p>
    ))
  }
  const renderTitle = content => {
    return (
      <h3 className='font-semibold text-lg mb-2'>
        <Trans
          i18nKey={content}
          components={[
            <strong key='0' />,
            <strong key='1' />,
            <strong key='2' />,
            <a key='link' href='https://swipey.ai/' target='_blank' rel='noopener noreferrer' />,
            <a key='mail' href='mailto:admin@invai.tech' />,
          ]}
        />
      </h3>
    )
  }

  // Рендер списка (ul/li)
  const renderList = list => {
    const items = Array.isArray(list) ? list : [list]
    return (
      <ul className='list-disc pl-6 mt-2 mb-4'>
        {items.map((item, idx) => (
          <li key={idx}>
            <Trans
              i18nKey={item}
              components={[
                <strong key='0' />,
                <strong key='1' />,
                <a key='link' href='https://swipey.ai/' target='_blank' rel='noopener noreferrer' />,
                <a key='mail' href='mailto:admin@invai.tech' />,
              ]}
            />
          </li>
        ))}
      </ul>
    )
  }

  // Рендер подсекции
  const renderSubsections = subsections => {
    if (!subsections) return null
    return Object.keys(subsections).map(subKey => {
      const sub = subsections[subKey]
      return (
        <div key={subKey} className='terms-subsection pl-4 mt-4'>
          <h4 className='font-medium mb-1'>{sub.title}</h4>
          {sub.paragraphs && renderContent(sub.paragraphs)}
          {sub.list && renderList(sub.list)}
        </div>
      )
    })
  }

  // Рендер основной секции
  const renderSection = (sectionKey, section) => (
    <div key={sectionKey} className='terms-section mb-6'>
      {section.title && renderTitle(section.title)}
      {section.paragraphs && renderContent(section.paragraphs)}
      {section.list && renderList(section.list)}
      {section.subsections && renderSubsections(section.subsections)}
    </div>
  )

  const sections = t('terms.sections', { returnObjects: true })

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onAccept={onAccept}
      title={t('terms.title')}
      acceptText={t('terms.accept')}
      closeText={t('terms.close')}
      maxWidth='1000px'
    >
      <div className='terms-content overflow-y-auto max-h-[80vh] px-4'>
        <p className='last-updated mb-4'>{t('terms.last_updated', { date: today })}</p>

        {Object.keys(sections).map(key => renderSection(key, sections[key]))}
      </div>
    </Modal>
  )
}

export default TermsOfService
